module.exports = __webpack_public_path__ + "img/service-digital-edu.b0334308.png";